module.exports = __webpack_public_path__ + "img/line.8ca3fa30.jpg";